import * as URL from "../../helpers/Constants";
import axios from "axios";

const mockPatients = [
    {id: 1, name: "Abid Shinepuk", phoneNumber: "+8809770012024", gender: "MALE", ageDays: 0, ageMonths: 0, ageYears: 41, lastVisitedDate: "2025-08-03T16:35:00", pharmacyId: null},
    {id: 2, name: "Abid Shinepuk", phoneNumber: "+8807770132024", gender: "FEMALE", ageDays: 0, ageMonths: 5, ageYears: 0, lastVisitedDate: "2025-08-03T16:28:00", pharmacyId: null},
    {id: 3, name: "Abid Shinepuk", phoneNumber: "+8809770012024", gender: "MALE", ageDays: 0, ageMonths: 0, ageYears: 41, lastVisitedDate: "2025-08-03T16:14:00", pharmacyId: null},
    {id: 4, name: "Abid Shinepuk", phoneNumber: "+8807770132024", gender: "FEMALE", ageDays: 0, ageMonths: 5, ageYears: 0, lastVisitedDate: "2025-08-03T16:35:00", pharmacyId: null},
];

export default class PMSPatientServices {

    static getAllPatientsByPharmacyId(pharmacyId, params) {
        // return axios.get(`${URL.PMS_GET_ALL_PATIENTS_BY_PHARMACY_ID}/${pharmacyId}`, {
        //     ...PMSPatientServices.getAuthHeader(),
        //     params,
        // });
        const {name = '', phoneNumber = '', page = 0, size = 10} = params || {};
        let filtered = mockPatients.filter(p =>
            p.name.toLowerCase().includes(name.toLowerCase()) &&
            p.phoneNumber.includes(phoneNumber)
        );
        const start = page * size;
        return Promise.resolve({
            data: {
                content: filtered.slice(start, start + size),
                totalElements: filtered.length,
            },
        });
    }

    static getPatientById(pharmacyId, id) {
        // return axios.get(`${URL.PMS_GET_PATIENT_BY_ID}/${pharmacyId}/${id}`, PMSPatientServices.getAuthHeader());
        const patient = mockPatients.find(p => p.id === Number(id)) || null;
        return Promise.resolve({data: patient});
    }

    static createPatient(pharmacyId, data) {
        // return axios.post(`${URL.PMS_CREATE_PATIENT_BY_PHARMACY_ID}/${pharmacyId}`, data, PMSPatientServices.getAuthHeader());
        const newPatient = {id: Date.now(), ...data, pharmacyId, lastVisitedDate: new Date().toISOString()};
        mockPatients.push(newPatient);
        return Promise.resolve({data: newPatient});
    }

    static updatePatientById(id, pharmacyId, data) {
        // return axios.put(`${URL.PMS_UPDATE_PATIENT_BY_ID}/${id}/${pharmacyId}`, data, PMSPatientServices.getAuthHeader());
        const idx = mockPatients.findIndex(p => p.id === Number(id));
        if (idx !== -1) mockPatients[idx] = {...mockPatients[idx], ...data};
        return Promise.resolve({data: mockPatients[idx]});
    }

    static deletePatientById(id) {
        // return axios.delete(`${URL.PMS_DELETE_PATIENT_BY_ID}/${id}`, PMSPatientServices.getAuthHeader());
        const idx = mockPatients.findIndex(p => p.id === Number(id));
        if (idx !== -1) mockPatients.splice(idx, 1);
        return Promise.resolve({data: {success: true}});
    }

    static getAuthHeader() {
        return {headers: {Authorization: `Bearer ${localStorage.getItem("oushodsheba_access_token")}`}};
    }
}
